(() => {
  const nav = document.querySelector(".mobile-bottom-nav");
  if (!nav) return;

  const MENU_TOGGLE = '#header [aria-controls="header-mobile-menu"]';
  const SHOP_DIALOG_ID = "mobile-bottom-nav-shop";
  let cartFetchTimer = 0;

  const countFromDetail = (detail) => {
    if (!detail) return null;
    if (typeof detail.item_count === "number") return detail.item_count;
    if (detail.cart && typeof detail.cart.item_count === "number") return detail.cart.item_count;
    if (Array.isArray(detail.items)) {
      return detail.items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
    }
    return null;
  };

  const applyCartCount = (count) => {
    const next = Math.max(0, Number(count) || 0);
    nav.querySelectorAll('[data-badge="cart"]').forEach((badge) => {
      badge.dataset.count = String(next);
      badge.textContent = String(next);
    });
  };

  const fetchCartCount = () => {
    window.clearTimeout(cartFetchTimer);
    cartFetchTimer = window.setTimeout(() => {
      fetch("/cart.js", { credentials: "same-origin" })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => {
          if (cart && typeof cart.item_count === "number") applyCartCount(cart.item_count);
        })
        .catch(() => {});
    }, 80);
  };

  const onCartEvent = (event) => {
    const count = countFromDetail(event.detail);
    if (count !== null) {
      applyCartCount(count);
      return;
    }
    fetchCartCount();
  };

  window.addEventListener("cart:added", onCartEvent);
  window.addEventListener("cart:changed", onCartEvent);
  window.addEventListener("cart:rendered", onCartEvent);
  window.addEventListener("cart:badge-optimistic", onCartEvent);

  nav.addEventListener("click", (event) => {
    const menuButton = event.target.closest("[data-mobile-bottom-nav-menu]");
    if (!menuButton) return;

    const toggler = document.querySelector(MENU_TOGGLE) || document.querySelector('[aria-controls="header-mobile-menu"]');
    if (!toggler) return;

    event.preventDefault();
    event.stopPropagation();

    document.querySelector("#header-group")?.classList.remove("hide");

    window.setTimeout(() => {
      toggler.click();
    }, 0);
  });

  const syncShopExpanded = (isOpen) => {
    nav.querySelectorAll(`[data-open-dialog="${SHOP_DIALOG_ID}"]`).forEach((button) => {
      button.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  };

  window.addEventListener("dialog:open", (event) => {
    if (event.detail?.dialog?.id === SHOP_DIALOG_ID) syncShopExpanded(true);
  });

  window.addEventListener("dialog:close", (event) => {
    if (event.detail?.dialog?.id === SHOP_DIALOG_ID) syncShopExpanded(false);
  });

  const menu = document.querySelector("#header-mobile-menu");
  if (menu) {
    const menuObserver = new MutationObserver(() => {
      const expanded = menu.hasAttribute("hidden") ? "false" : "true";
      nav.querySelectorAll("[data-mobile-bottom-nav-menu]").forEach((button) => {
        button.setAttribute("aria-expanded", expanded);
      });
    });
    menuObserver.observe(menu, { attributes: true, attributeFilter: ["hidden"] });
  }
})();
